import React from "react";
import "./ReorderProductCard.css";
import { clientConfig } from "../../../../config";
import * as translator from "../../../../utils/translator"
import { useParams } from "react-router-dom";

interface ReorderProductCardProps {
  productImgSrc: string;
  productTitle: string;
  productQuantity: string;
  productPrice: number;
  isProductInStock?: boolean
  currencyRate: number
}

const ReorderProductCard:React.FC<ReorderProductCardProps> = ({productImgSrc,productTitle,productQuantity,productPrice, isProductInStock, currencyRate=1}) => {
  const {country, language} = useParams();
  const locale = language?.toLowerCase() + '-' + country?.toUpperCase();

  return (
    <div className={`reorder-product-card ${isProductInStock ? "" : "reorder-product-out-of-stock-card"}`}>

      {
        //TODO: translations
        isProductInStock ? null : <span id="reorder-product-card-tag">OUT OF STOCK</span>
      }

      <div className="img-container">
        <img
          src={`${clientConfig.IMAGES_URL}${productImgSrc}`}
          alt="product-img"
        />
      </div>
      <div className="texts-container">
        <h3 className="reorder-product-card-title"> {productTitle}</h3>
        <span className="reorder-product-card-quantity">{productQuantity}</span>
        <p className="total-price-row">
          <span className="total-vat">{translator.translate(language, "reorder", "ReorderProductCard/medication")}</span>
          <span>{translator.getPrice(productPrice, locale, currencyRate)}</span>
        </p>
      </div>
    </div>
  );
};

export default ReorderProductCard;
